import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'
import { useUserInfo } from '../../../hooks/useUserInfo'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

import { ReactComponent as BankIcon } from '../../../assets/gui/bank.svg'

export function CreateAccountModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()
  const { data: userInfo } = useUserInfo()

  const createAccount = () => {
    if (!userInfo) return

    sessionStorage.setItem('createAccountSuccessCallbackLink', `${location.pathname}?hasCreateAccount=true`)
    closeModal(MODALS_ID.CREATE_ACCOUNT)

    const isWithdrawalAccount = !!userInfo.withdrawalAccount
    navigate(
      isWithdrawalAccount ? '/account/deposit/terms' : '/account/withdrawal/create',
      isWithdrawalAccount ? { state: { prevPathname: window.location.pathname } } : undefined,
    )
  }

  return (
    <Modal id={MODALS_ID.CREATE_ACCOUNT}>
      <Content>
        <BankIcon />
        <Text size={16} weight={500} $textAlign="center" $wordBreak="keep-all">
          NH농협 예치금 계좌를 개설해야 청약이 가능해요.
        </Text>
      </Content>
      <Modal.Footer>
        <Button type="primary" onClick={createAccount}>
          계좌 개설하기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`
